import cloneDeep from 'lodash/cloneDeep';
import { Insurance, InsuranceSource } from 'store/profile/types';
import { orFallbackArray } from '../utils';
import {
  AzureFilter,
  AzureFacet,
  ProviderFilterGroups,
  ProviderSearchPayload,
  ProviderFacetGroups
} from './types';

export function insuranceIdsRequestDTO(insurances: Insurance[]) {
  const result: string[] = [];
  insurances.forEach((ins: Insurance) => {
    switch (ins.source) {
      case InsuranceSource.SELECT_HEALTH: {
        result.push(`${ins.networkId}`);
        break;
      }
      case InsuranceSource.MILLENNIUM: {
        if (ins.planId) {
          result.push(`${ins.planId}`);
        } else {
          result.push(`${ins.planCode}`);
        }
        break;
      }
      default:
        result.push(`${ins.planId}`);
    }
  });
  return result;
}

export function facetsRequestDTO(facets?: AzureFacet[]) {
  facets = orFallbackArray(cloneDeep(facets)).map(facet => {
    delete facet.title;
    return facet;
  });

  const hasDistance = facets?.some(facet => facet.group === ProviderFacetGroups.locationDistance);
  const defaultDistanceFacet = { group: ProviderFacetGroups.locationDistance, value: 9999 };

  return hasDistance ? facets : [...facets, defaultDistanceFacet];
}

export function filtersRequestDTO(filters?: AzureFilter[], selectHealth = false) {
  filters = orFallbackArray(cloneDeep(filters))
    .map(filter => {
      delete filter.title;
      return filter;
    })
    .filter(filter => filter.value);

  const healthClassFilter = selectHealth
    ? { group: ProviderFilterGroups.isSelectHealth, value: true }
    : { group: ProviderFilterGroups.isInterMountain, value: true };

  return [...filters, healthClassFilter];
}

export function storedPayloadDTO({ input, options }: ProviderSearchPayload) {
  const cleanFilters = options.filters?.filter?.(f => {
    return (
      f.group !== ProviderFilterGroups.isSelectHealth &&
      f.group !== ProviderFilterGroups.isInterMountain
    );
  });

  return { ...options, input, filters: cleanFilters };
}
